import styled from 'styled-components';

export const StyledMessage = styled.div`
    display: flex;
    padding: 0 5%;
    margin-top: 20px;
    
`